module.exports = "table {\r\n\twidth: 100%;\r\n}\r\n\r\nthead, tbody, tr, td, th { display: block; }\r\n\r\ntr:after {\r\n\tcontent: ' ';\r\n\tdisplay: block;\r\n\tvisibility: hidden;\r\n\tclear: both;\r\n}\r\n\r\nthead th {\r\n\theight: 50px;\r\n\r\n\t/*text-align: left;*/\r\n}\r\n\r\ntbody {\r\n\theight: 450px;\r\n\toverflow-y: auto;\r\n}\r\n\r\nthead {\r\n\t/* fallback */\r\n}\r\n\r\ntbody td, thead th {\r\n\r\n\tfloat: left;\r\n\t\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/physical-web-order/physical-web-order.component.css
// module id = ./src/app/shoppingcart/physical-web-order/physical-web-order.component.css
// module chunks = main